import React from "react";
import PropTypes from "prop-types";

// Styles
import {
  StyledInputSwitch,
  StyledInputSwitchSpan,
  StyledInputSwitchContent,
  StyledInputSwitchText,
} from "./InputSwitch.styles";

/**
 * Input Routes component
 */
export const InputSwitch = (props) => {
  const { id = "", name = "", label = "Inactivo", onChange = () => {}, defaultChecked = false, className, value } = props;

  // Determine if component should be controlled or uncontrolled
  const isControlled = value !== undefined;

  return (
    <StyledInputSwitchContent className={className}>
      <StyledInputSwitch htmlFor={id}>
        <input
          type="checkbox"
          id={id}
          name={name}
          onChange={onChange}
          {...(isControlled ? { checked: value } : { defaultChecked })}
        />
        <StyledInputSwitchSpan />
        <StyledInputSwitchText>{label}</StyledInputSwitchText>
      </StyledInputSwitch>
    </StyledInputSwitchContent>
  );
};

InputSwitch.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  defaultChecked: PropTypes.bool,
  className: PropTypes.string,
};

export default InputSwitch;
